import 'angular:locale/data:es';
import 'zone.js';(globalThis.$localize ??= {}).locale = "es";
